.handDrawerWrapper {
}

.cards {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

.card {
  &.clickable {
    cursor: pointer;
  }

  &.selected,
  &.highlighted {
    position: relative;
    top: -5px;
  }

  &.selected {
    border: 2px solid aqua;
  }

  &.faded,
  &.fadeUnclickable {
    filter: blur(0.6px) saturate(0.7) brightness(0.6);
  }
}

.card + .card {
  margin-left: 8px;
}
